import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { BidStatusEnum } from '../../../../models/Auction';
import { useUserContext } from '../../../../providers';
import { BidCard } from '../../../../widgets/bid-card';
import { useAuctionContext } from '../../../../providers/AuctionProvider/AuctionProvider';
import { useBidServiceContext } from '../../../../providers/BidServiceProvider/BidServiceProvider';

export const AuctionViewBidsMy = () => {
  const { t } = useTranslation(['translation']);
  const { id } = useParams();
  const { user } = useUserContext();
  const { getMyBidForAuction } = useBidServiceContext();
  const { auction, bids, auctionStatus, getIsWinner } = useAuctionContext();
  const winnersLenght = (bids?.filter((bid) => getIsWinner(bid)) || [])?.length;
  const number_winners =
    auction?.number_winners &&
    winnersLenght < auction?.number_winners &&
    auctionStatus === BidStatusEnum.COMPLETED
      ? winnersLenght
      : auction?.number_winners || 0;

  const userBid = bids?.findIndex((bid) => bid.user.guid === user?.guid);
  const myBid = id ? getMyBidForAuction(parseInt(id)) : null;

  if (
    !myBid?.bid_amount ||
    (typeof userBid !== 'undefined' && userBid > -1
      ? !(userBid + 1 > number_winners && userBid !== 0)
      : false)
  )
    return null;

  return (
    <>
      <div className={'flex w-full items-center justify-between'}>
        <p className={'text-[16px] font-[600] text-gray-900'}>{t('bid.My_bet')}</p>
      </div>
      <BidCard
        bid={myBid}
        place={
          typeof userBid !== 'undefined'
            ? (userBid + 1 !== number_winners && userBid !== 0) ||
              userBid > number_winners
              ? userBid + 1
              : undefined
            : undefined
        }
        isMy
        isWin={
          auctionStatus === BidStatusEnum.ACTIVE
            ? typeof userBid !== 'undefined' && userBid < number_winners
            : auctionStatus === BidStatusEnum.COMPLETED
              ? typeof userBid !== 'undefined' &&
                userBid > 0 &&
                userBid < number_winners
              : undefined
        }
        canBid={
          typeof userBid !== 'undefined' &&
          auctionStatus === BidStatusEnum.ACTIVE &&
          userBid >= number_winners
        }
      />
    </>
  );
};
